module.exports = __webpack_public_path__ + "img/p15.ccf60510.png";